<template>
  <DisplayContainer label="Externe Benutzer Verwaltung">
    <ExternalUserTable />
  </DisplayContainer>
</template>

<script>
import DisplayContainer from '@/components/elements/DisplayContainer.vue';
import ExternalUserTable from '@/components/externalAccount/ExternalUserTable.vue';

export default {
  name: 'ExternalAccountManager',
  components: {
    DisplayContainer,
    ExternalUserTable
  },
  data: () => ({
    tab: null
  }),
  methods: {}
};
</script>
<style lang="scss" scoped></style>
